// extracted by mini-css-extract-plugin
module.exports = {"ReportTitle":"Page_ReportTitle__fHcGq","MainWrapper":"Page_MainWrapper__T_Eqi"};